/**
 *
 * Button
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';

import style from './style.module.scss';

let clickedTimeout = null;

const handleDoubleClick = onClick => {
  if (!clickedTimeout) {
    onClick();
    clickedTimeout = setTimeout(() => {
      clickedTimeout = null;
    }, 2000);
  }
};

const Button = props => (
  <button
    className={props.className ? `${props.className} ${style[props.className] || ''}`.trim() : undefined}
    onClick={() => handleDoubleClick(props.onClick)}
  >
    {props.text}
    {props.adornment && (
      <span className={`material-icons ${style.materialIcon}`}>{props.adornment}</span>
    )}
  </button>
);

Button.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
  adornment: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

export default Button;
